import { render, staticRenderFns } from "./HotelPaymentContainer.vue?vue&type=template&id=3a8e32b8&"
import script from "./HotelPaymentContainer.vue?vue&type=script&setup=true&lang=js&"
export * from "./HotelPaymentContainer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports